import { useFlags } from "flagsmith/react";

import { GLOBAL_FLAGS_ENUM as FLAGS } from "@utils/featureFlags";

export const useSystemModulesAuthFlag = (): boolean => {
  const flags = useFlags([FLAGS.FEATURE_ENABLE_SYSTEM_MODULES_AUTH]);
  return !!flags[FLAGS.FEATURE_ENABLE_SYSTEM_MODULES_AUTH]?.enabled;
};
